import Celebration from './Celebration';
export default Celebration;